import { render, staticRenderFns } from "./SearchScheme.vue?vue&type=template&id=0a122872&scoped=true"
import script from "./SearchScheme.vue?vue&type=script&lang=js"
export * from "./SearchScheme.vue?vue&type=script&lang=js"
import style0 from "./SearchScheme.vue?vue&type=style&index=0&id=0a122872&prod&scoped=true&lang=css"
import style1 from "./SearchScheme.vue?vue&type=style&index=1&id=0a122872&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a122872",
  null
  
)

export default component.exports